


















































































import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { ActionMethod } from 'vuex';
import { Action } from 'vuex-class';
import SvgIcon from '@/components/SvgIcon.vue';
import ApplicationActionTypes from '@/modules/application/ApplicationActionTypes';

@Component({
  name: 'MarketFooter',
  components: {
    SvgIcon,
  },
})
export default class MarketFooter extends Vue {
  @Prop({ default: false }) protected isMarket!: boolean;

  @Prop({ default: false }) protected noSectionGetStartedWithDpgo!: any;

  @Action(ApplicationActionTypes.LIVECHAT_SHOW, { namespace: 'application' })
  protected dispatchSupportShow!: ActionMethod;
}
